/**
 * TemplateSkeletons - Template card and grid loading states
 */
import React from 'react';
import { Skeleton } from './BaseSkeleton';

export function TemplateCardSkeleton() {
  return (
    <div className="relative aspect-square w-full rounded-lg bg-white dark:bg-gray-900 overflow-hidden shadow-sm border border-gray-200 dark:border-gray-800">
      {/* Image area (gray background) */}
      <Skeleton className="absolute inset-0 w-full h-full" />
      
      {/* Bottom gradient overlay - always visible */}
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-black/70 to-transparent">
        {/* Title */}
        <div className="absolute bottom-4 left-4 right-4">
          <Skeleton className="h-4 w-2/3 mb-2" />
          <Skeleton className="h-3 w-1/3" />
        </div>
      </div>
      
      {/* Top-right buttons as circles */}
      <div className="absolute top-3 right-3 flex space-x-2">
        <Skeleton className="h-8 w-8 rounded-full" />
        <Skeleton className="h-8 w-8 rounded-full" />
      </div>
      
      {/* Top-left button as circle */}
      <div className="absolute top-3 left-3">
        <Skeleton className="h-8 w-8 rounded-full" />
      </div>
    </div>
  );
}

export function TemplateGridSkeleton({ columns = 4 }) {
  // Create an array based on the number of columns to show (default 4)
  const skeletonItems = Array.from({ length: columns * 2 }, (_, i) => (
    <div key={i} className="w-full">
      <TemplateCardSkeleton />
    </div>
  ));
  
  return (
    <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {skeletonItems}
    </div>
  );
}

export function EnterpriseLogoSkeleton({ isOpen = true }) {
  if (isOpen) {
    // Full width skeleton when sidebar is open
    return (
      <div className="flex items-center p-3 rounded-lg">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-gray-200 dark:bg-gray-800">
          <Skeleton className="h-6 w-6 rounded" />
        </div>
        <div className="ml-3 flex-1">
          <Skeleton className="h-4 w-24 mb-1" />
          <Skeleton className="h-3 w-20" />
        </div>
      </div>
    );
  } else {
    // Collapsed sidebar - just show the icon skeleton
    return (
      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-gray-200 dark:bg-gray-800">
        <Skeleton className="h-6 w-6 rounded" />
      </div>
    );
  }
}

